import {
    MemberPaymentAction,
    MemberPaymentState,
    StripeMessage,
    initialMemberPaymentState,
    initialStripeMessage,
} from './MemberPaymentContext.interface';

import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import { MemberPaymentActionType } from 'modules/common/components/Payment/MemberPaymentContext/mappers';

export const actions = {
    openModal: () => ({ type: MemberPaymentActionType.OPEN_MODAL } as const),
    closeModal: () => ({ type: MemberPaymentActionType.CLOSE_MODAL } as const),
    setStripeTokenId: (id: string) => ({ type: MemberPaymentActionType.SET_TOKEN, payload: id } as const),
    setIsToSChecked: (checked: boolean) =>
        ({ type: MemberPaymentActionType.SET_TOS_CHECKED, payload: checked } as const),
    setStripeMessage: (msg: Partial<StripeMessage>) =>
        ({ type: MemberPaymentActionType.SET_MESSAGE, payload: msg } as const),
    resetStripeMessage: () => ({ type: MemberPaymentActionType.RESET_MESSAGE } as const),
    setUpdating: (updating: boolean) => ({ type: MemberPaymentActionType.SET_UPDATING, payload: updating } as const),
    reset: () => ({ type: MemberPaymentActionType.RESET } as const),
} as const;

export function memberPaymentReducer(state: MemberPaymentState, action: MemberPaymentAction): MemberPaymentState {
    if (action === null || action === undefined) {
        return state;
    }

    switch (action.type) {
        case MemberPaymentActionType.OPEN_MODAL: {
            if (state.isPaymentModalOpen) {
                return state;
            }
            return { ...state, isPaymentModalOpen: true };
        }

        case MemberPaymentActionType.CLOSE_MODAL: {
            if (!state.isPaymentModalOpen) {
                return state;
            }
            return { ...state, isPaymentModalOpen: false };
        }

        case MemberPaymentActionType.SET_TOKEN: {
            if (state.stripeTokenId === action.payload) {
                return state;
            }
            return { ...state, stripeTokenId: action.payload };
        }

        case MemberPaymentActionType.SET_TOS_CHECKED: {
            if (state.isToSChecked === action.payload) {
                return state;
            }
            return { ...state, isToSChecked: action.payload };
        }

        case MemberPaymentActionType.SET_MESSAGE: {
            return { ...state, stripeMessage: { ...state.stripeMessage, ...action.payload } };
        }

        case MemberPaymentActionType.RESET_MESSAGE: {
            return { ...state, stripeMessage: initialStripeMessage };
        }

        case MemberPaymentActionType.SET_UPDATING: {
            if (state.isUpdating === action.payload) {
                return state;
            }
            return { ...state, isUpdating: action.payload };
        }

        case MemberPaymentActionType.RESET: {
            return initialMemberPaymentState;
        }

        default: {
            if (process.env.NODE_ENV !== 'production') {
                sendDatadogRumError(
                    'MemberPaymentContext.memberPaymentReducer',
                    new Error(`Unhandled action type: ${(action as MemberPaymentAction).type}`),
                    {
                        source: 'MemberPaymentContext',
                    }
                );
                throw new Error(`Unhandled action type: ${(action as MemberPaymentAction).type}`);
            }
            return state;
        }
    }
}
